module.exports = __webpack_public_path__ + "img/fp-landing-slide.06385e2c.png";